import ModernIcon from '@/assets/font-icons/Modern.svg'
import HeavyIcon from '@/assets/font-icons/Heavy.svg'
import ShoutIcon from '@/assets/font-icons/Shout.svg'
import OldeStyleIcon from '@/assets/font-icons/Old Style.svg'
import MysticIcon from '@/assets/font-icons/Mystic.svg'
import SharpIcon from '@/assets/font-icons/Sharp.svg'
import VogueIcon from '@/assets/font-icons/Vogue.svg'
import TypewriterIcon from '@/assets/font-icons/Typewriter.svg'
import GothicIcon from '@/assets/font-icons/Gothic.svg'
import PixelIcon from '@/assets/font-icons/Pixel.svg'
import MarkerIcon from '@/assets/font-icons/Marker.svg'
import WaveyIcon from '@/assets/font-icons/Wavey.svg'
import { DefineComponent } from 'vue'

export enum Fonts {
  MODERN = 'Work Sans Bold',
  HEAVY = 'Work Sans Black',
  SHOUT = 'Bebas Neue',
  OLD_STYLE = 'Fraunces',
  MYSTIC = 'Aladin',
  SHARP = 'Bluu Next',
  VOGUE = 'Oranienbaum',
  TYPEWRITER = 'Special Elite',
  GOTHIC = 'Cloister',
  PIXEL = 'Press',
  MARKER = 'Permanent Marker',
  WAVEY = 'Bellybeans',
}

export interface FontData {
  name: string
  icon: DefineComponent
}

export const fonts: FontData[] = [
  {
    name: Fonts.MODERN,
    icon: ModernIcon
  },
  {
    name: Fonts.HEAVY,
    icon: HeavyIcon
  },
  {
    name: Fonts.SHOUT,
    icon: ShoutIcon
  },
  {
    name: Fonts.OLD_STYLE,
    icon: OldeStyleIcon
  },
  {
    name: Fonts.MYSTIC,
    icon: MysticIcon
  },
  {
    name: Fonts.SHARP,
    icon: SharpIcon
  },
  {
    name: Fonts.VOGUE,
    icon: VogueIcon
  },
  {
    name: Fonts.TYPEWRITER,
    icon: TypewriterIcon
  },
  {
    name: Fonts.GOTHIC,
    icon: GothicIcon
  },
  {
    name: Fonts.PIXEL,
    icon: PixelIcon
  },
  {
    name: Fonts.MARKER,
    icon: MarkerIcon
  },
  {
    name: Fonts.WAVEY,
    icon: WaveyIcon
  }
]
